import styled from "styled-components";

export const MainPageLayoutStyle = styled.div`
  background-color: #1a1a1d;
  height: 100%;
  min-height: 100vh;
  .navLinkWrapper {
    position: fixed;
    bottom: 10px;
    right: 0px;
    text-align: center;
    /* background-color: lightblue; */
    border-radius: 60px;
    /* padding: 10px; */
    display: none;
    .navLinks {
      flex-direction: column;
      /* border-radius: 50%; */
      padding: 5px;
      visibility: hidden;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      overflow: hidden;
      -webkit-transition: all 0.5s ease-in-out;
      -moz-transition: all 0.5s ease-in-out;
      -o-transition: all 0.5s ease-in-out;
      transition: all 0.5s ease-in-out;
      a {
        color: whitesmoke;
        font-weight: 700;
        font-size: 1.3rem;
        margin: 10px 0px;
        &.active {
          color: lightcoral;
        }
      }
    }
    button {
      padding: 5px;
      border-radius: 50%;
      padding: 5px 8px;
      background-color: inherit;
      border: 2px solid white;
      i {
        color: salmon;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .navLinkWrapper {
      display: block;
    }
  }
`;
